import React from 'react';

const Container = (props) => (
  <div className="container" style={props.style}>
    {props.children}
  </div>
)
const Row = (props) => (
  <div className="row" style={props.style}>
    {props.children}
  </div>
)
const Col = (props) => (
  <div className={"col-md-" + props.cols} style={props.style}>
    {props.children}
  </div>
)

export { Container, Row, Col };



// WEBPACK FOOTER //
// ./src/BootstrapGrid.js